import { Container, Row, Col, Nav, Tab, Accordion } from "react-bootstrap";
import { useEffect } from "react";
import useLang from "hooks/useLang";
import barcode from "../../assets/images/services/barcode-individual.jpeg"
import SideBar from "components/our-services/SideBar";

const IndividualPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();
  
  return (
    <div>
      <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
        <h2>{lang.services.lists.list_1.title}</h2>
        <Tab.Container id="individual-services" defaultActiveKey="first">
          <Row>
            <Row sm={12} className="justify-center nav-row">
              <Nav variant="pills" className="flex-row services-nav-tab">
                <Nav.Item>
                  <Nav.Link className="border-radius-30px" eventKey="first">
                    {lang.services.lists.list_1.nav_1.title}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="border-radius-30px" eventKey="second">
                    {lang.services.lists.list_1.nav_2.title}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className="border-radius-30px" eventKey="third">
                    {lang.services.lists.list_1.nav_3.title}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Row>
            <Row>
              <Col>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <h6>{lang.services.lists.list_1.nav_1.sub_title}</h6>
                    <p>{lang.services.lists.list_1.nav_1.description}</p>
                    <p>{lang.services.lists.list_1.nav_1.include}</p>
                    <Accordion defaultActiveKey={["0"]}>
                      {lang.services.lists.list_1.nav_1.accordion.map(l => {
                        return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                          <Accordion.Header>{l.header}</Accordion.Header>
                          <Accordion.Body>{l.body}</Accordion.Body>
                        </Accordion.Item>
                      })}
                    </Accordion>
                    <p style={{ marginTop: "20px" }}>{lang.services.lists.list_1.nav_1.closing_paragraph}</p>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <h6>{lang.services.lists.list_1.nav_2.sub_title}</h6>
                    {lang.services.lists.list_1.nav_2.paragraphs.map(l => {
                      return <p>{l}</p>
                    })}
                  </Tab.Pane>
                  <Tab.Pane eventKey="third">
                    <h6>{lang.services.lists.list_1.nav_3.sub_title}</h6>
                    <p>
                      {lang.services.lists.list_1.nav_3.paragraph_1}
                      <span className="underlined-yellow">
                        {lang.services.lists.list_1.nav_3.paragraph_2}
                      </span>
                      {lang.services.lists.list_1.nav_3.paragraph_3}
                    </p>
                    <p>{lang.services.lists.list_1.nav_3.paragraph_4}</p>
                    <Accordion defaultActiveKey={["0"]}>
                      {lang.services.lists.list_1.nav_3.accordion.map(l => {
                        return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                          <Accordion.Header>{l.header}</Accordion.Header>
                          <Accordion.Body>{l.body}</Accordion.Body>
                        </Accordion.Item>
                      })}
                    </Accordion>
                    <p style={{ marginTop: "20px" }}>
                      {lang.services.lists.list_1.nav_3.closing_paragraph}
                    </p>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
              <SideBar barcode={barcode}/>
            </Row>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  );
};

export default IndividualPage;
